import { FormattedMessage } from 'react-intl';

import './SuccessToast.sass';

const SuccessToast = ({ successMessage, closeSuccessToast }: { successMessage: string; closeSuccessToast: () => void }) => {
	return (
		<dialog id="copy-toast" open={!!successMessage} onClick={closeSuccessToast}>
			<span className="icon icon-copy" />
			{successMessage !== null && (
				<span>
					<FormattedMessage id={`${successMessage}`} />
				</span>
			)}
		</dialog>
	);
};

export default SuccessToast;
